<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" class="btn btn-rounded btn-block-xs-only" style="background: rgb(128, 0, 128); color: #fff;">
            Add New Passcard
          </button>
          </AppAddButton>
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="onSearchChange" />
        
      </div>
      
      <AppFilter 
        ref="movementFilter" 
        v-on:filter-data-change="onFilterDataChange" />

      <AppFilter 
        ref="conditionFilter" 
        v-on:filter-data-change="onFilterDataChange" />

      <AppFilter 
        ref="pageFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterDataChange" />

      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />
      
      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />
      
      <AppModalForm 
        ref="pageModalSubscription" 
        v-bind:formParameter="SUBSCRIPTION_PARAM" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PASSCARD_MOVEMENT = [
  'In Stock',
  'Issued',
  'Returned',
  'Lost'
  // {1: 'In Stock'},
  // {2: 'Issued'},
  // {3: 'Returned'},
  // {4: 'Lost'}
];
const PASSCARD_CONDITION = [
  'Good',
  'Damaged',
  'Faulty',
  'Suspended'
  // {1: 'Good'},
  // {2: 'Damaged'},
  // {3: 'Faulty'},
  // {4: 'Suspended'}
];
const PASSCARD_BLOCKDED = [
  {1: 'Blocked'},
  {0: 'Not Blocked'},
];

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'passtypeID',
    text: 'Passcard Type',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_default: 10,
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    table_hide: true,
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    }
  },
  {
    key: 'sku',
    text: 'Passcard Number',
    table_popup: true, 
  },
  {
    key: 'passtype',
    text: 'Passcard Type',
    form_hide: true,
    form_input_validation: [],
  },
  {
    key: 'movement',
    text: 'Movement',
    // table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
    //   let parameterItem = dataParameter[parameterIndex];
    //   let dataItem = dataResult[dataIndex];

    //   let movementKey = dataItem.movements;
    //   let movement = PASSCARD_MOVEMENT.find(k => k[movementKey]);
    //   movement = movement ? movement[movementKey] : 'Movement: ' + movementKey;

    //   return movement;
    // },
    form_select: PASSCARD_MOVEMENT,
    form_default: 'In Stock',
  },
  {
    key: 'conditions',
    text: 'Condition',
    // table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
    //   let parameterItem = dataParameter[parameterIndex];
    //   let dataItem = dataResult[dataIndex];

    //   let conditionKey = dataItem.conditions;
    //   let condition = PASSCARD_CONDITION.find(k => k[conditionKey]);
    //   condition = condition ? condition[conditionKey] : 'Condition: ' + conditionKey;

    //   return condition;
    // },
    form_select: PASSCARD_CONDITION,
    form_default: 'Good',
  },
  {
    key: 'isBlocked',
    text: 'Is Blocked',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      
      let blockedKey = dataItem.isBlocked;
      let blocked = PASSCARD_BLOCKDED.find(k => k[blockedKey]);
      blocked = blocked ? blocked[blockedKey] : 'Blocked: ' + blockedKey;

      return blocked;
    },
    form_radio: PASSCARD_BLOCKDED,
    form_default: 0,
  },
  {
    key: '_subscription',
    text: 'Subscription',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      
      if(dataItem.movement === 'In Stock' || dataItem.movement === 'Returned' || dataItem.movement === 'Lost') {
        return 'N/A';
      }
      if(!dataItem.leaseID) {
        return 'N/A';
      }

      return '<a href="#">Subscription</a>';
    },
    table_popup: 'div',
    form_hide: true,
    form_input_validation: [],
  },
];

const SUBSCRIPTION_PARAM = [
  {
    key: 'license',
    text: 'Parking License',
    form_add_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'account',
    text: 'Account Holder',
    form_add_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'name',
    text: 'Parker Full Name',
    form_add_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'mobile',
    text: 'Mobile No.',
    form_add_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'email',
    text: 'Email',
    form_add_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'car1',
    text: 'Car Plate',
    form_add_input_attr: {
      disabled: true,
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePasscard",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Passcard' },
        { name: 'All Passcard' },
      ],

      PARAM,
      PARAM_MAP,
      SUBSCRIPTION_PARAM,

      pagePasscard: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    
    // let temp = [{id: '', name: 'All Movements'}];
    // for(let movement of PASSCARD_MOVEMENT) {
    //   temp.push({id: Object.keys(movement)[0], name: movement[Object.keys(movement)[0]]});
    // }
    // this.$refs['movementFilter'].setFilterDataWithDefault(temp);

    // let temp1 = [{id: '', name: 'All Conditions'}];
    // for(let movement of PASSCARD_CONDITION) {
    //   temp1.push({id: Object.keys(movement)[0], name: movement[Object.keys(movement)[0]]});
    // }
    // this.$refs['conditionFilter'].setFilterDataWithDefault(temp1);

    this.loadCarpark();
  },
  methods: {
    loadCarpark() {
      this.$refs['pageFilter'].setFilterLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad([].concat({name: 'All Car Parks'}, response.data), this.$route.query.carparkID);
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);
          this.loadPasscardType();
        })
        .catch(error => {
          this.$refs['pageFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadPasscardType() {
      this.$refs['pageTable'].setTableLoading('Loading passcard type data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/passtype',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          helper.inputSelectSetOption(this.PARAM_MAP['passtypeID'], response.data);
          this.loadLease();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'passcard type data'));
        });
    },
    loadLease() {
      this.$refs['pageTable'].setTableLoading('Loading lease data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/lease',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageLease = response.data;
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'lease data'));
        })
    },
    loadData() {
      this.$refs['pageTable'].setTableLoading();

      let url = this.getUrl(this.$refs['pageFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      url = helper.appendPagingQuery(url, this.$refs['pageTable'].getCurrentPage());
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
          response.data.forEach(k => {
            k['passtype'] = (helper.inputSelectFindOption(this.PARAM_MAP['passtypeID'], k['passtypeID']) || {})['name'];

            let lease = this.pageLease.find(j => helper.compareID(j.passcardID, k['id'])) || {};
            k['leaseID'] = lease.id;
          });
          this.pagePasscard = response.data
          this.$refs['pageTable'].setTableData(response.data, this.$refs['pageTable'].getCurrentPage());
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'level data'));
        })
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/passcard/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();
      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['carparkID'] = this.$refs['pageFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add New Passcard', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let parameter = tableParameter[tableParameterIndex];

      this.$refs['pageFeedback'].setFeedbackMessage();
      if(parameter.key === 'sku') {
        if(tableData[tableDataIndex]['movement'] === 'Issued' || tableData[tableDataIndex]['movement'] === 'Returned' || tableData[tableDataIndex]['movement'] === 'Lost') {
          this.PARAM_MAP['conditions']['form_edit_input_attr'] = {disabled : true};
          this.PARAM_MAP['movement']['form_edit_input_attr'] = {disabled : true};
        } else {
          this.PARAM_MAP['conditions']['form_edit_input_attr'] = {};
          this.PARAM_MAP['movement']['form_edit_input_attr'] = {};
        }
        this.$refs['pageModal'].setModalOpen(false, 'Edit ' + tableData[tableDataIndex]['sku'], tableData[tableDataIndex]);
      } else if(parameter.key === '_subscription') {
        this.SUBSCRIPTION_PARAM.forEach(k => k.form_hide = true);
        this.$refs['pageModalSubscription'].setModalOpen(true, 'Subscription');
        this.loadSubscription(tableData[tableDataIndex]);
      }
    },

    async loadSubscription(data) {
      let lease = this.pageLease.find(k => helper.compareID(k.passcardID, data['id']));
      if(!lease) {
        this.$refs['pageModalSubscription'].setModalError('Problem loading ' + data.sku + ' lease info');
        return;
      }
      
      let feedbackItem = 'license data';
      this.$refs['pageModalSubscription'].setModalLoading('Loading ' + feedbackItem);
      let licenseResult = await this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + lease.licenseID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data[0];
        })
        .catch(error => {
          this.$refs['pageModalSubscription'].setModalError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });

      if(!licenseResult) {
        this.$refs['pageModalSubscription'].setModalError('Problem loading ' + feedbackItem);
        return;
      }

      feedbackItem = 'account data';
      this.$refs['pageModalSubscription'].setModalLoading('Loading ' + feedbackItem);
      let accountResult = await this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + licenseResult.customerID,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data[0];
        })
        .catch(error => {
          this.$refs['pageModalSubscription'].setModalError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });

      if(!accountResult) {
        this.$refs['pageModalSubscription'].setModalError('Problem loading ' + feedbackItem);
        return;
      }

      feedbackItem = 'parker data';
      this.$refs['pageModalSubscription'].setModalLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + accountResult.id + '/parker/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.SUBSCRIPTION_PARAM.forEach(k => k.form_hide = false);
          this.$refs['pageModalSubscription'].setModalMessage();

          let temp = response.data.find(k => helper.compareID(k.id, lease.parkerID));
          let formData = this.$refs['pageModalSubscription'].$refs['modalForm'].formData;
          formData['name'] =  temp['name'];
          formData['mobile'] = temp['username'];
          formData['email'] = temp['email'];
          formData['car1'] = temp['car1'] + ' '; // TODO weird bug?
          formData['account'] = accountResult['name'];
          formData['license'] = helper.plFormPLNum(licenseResult['licenseOperatorNum'], licenseResult['carparkID']);
        })
        .catch(error => {
          this.$refs['pageModalSubscription'].setModalError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },

    onModalAddDataClick(selectedData) {
      if(this.checkDuplicatePasscard(selectedData)) return;

      this.$refs['pageModal'].setModalLoading('Adding ' + selectedData.sku);
      this.$http
        .post(
          this.getUrl(selectedData.carparkID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterValue(selectedData.carparkID);
          this.upsertDataComplete('Successfully added ' + selectedData.sku);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })
    },
    onModalEditDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Updating ' + selectedData.sku);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/passcard/' + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + selectedData.sku);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })
    },
    onModalDeleteDataClick(selectedData) {
      this.$refs['pageModal'].setModalLoading('Deleting ' + selectedData.name);
      this.$http
        .delete(
          helper.SERVER_URL + '/api2/passcard/' + selectedData.id,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + selectedData.name);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
        })
    },
    checkDuplicatePasscard(selectedData) {
      if(this.pagePasscard.some(k => helper.compareID(k['carparkID'], selectedData['carparkID']) && helper.compareID(k['passtypeID'], selectedData['passtypeID']) && k['sku'] === selectedData['sku'])) {
        this.$refs['pageModal'].setModalError('This passcard number and type already exist in this car park.');
        return true;
      }
    },
    upsertDataComplete(message) {
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Passcard/PagePasscard.vue